import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { NegotiationStatus } from "@/modules/candidate/constants/negotiationStatus"
import { UserModel } from "@/modules/users/models/userModel"

export interface EndConsultantOfferData {
  uid: string
  status: NegotiationStatus
  endDate: string
  message?: string
  proposedBySupplier?: boolean
  created: string
  reviewed?: boolean
  responseMessage?: string
  respondedAt?: string
  proposer?: UserModel | null
  respondedBy?: UserModel | null
}

@Serializable
export class EndConsultantOfferModel {
  uid: string = ""
  status: NegotiationStatus = NegotiationStatus.NotDefined
  endDate: string = ""
  message: string = ""
  proposedBySupplier: boolean = false
  created: string = ""
  reviewed: boolean = false
  responseMessage: string = ""
  respondedAt: string = ""
  proposer: UserModel | null = null
  respondedBy: UserModel | null = null

  constructor(data: EndConsultantOfferData | null = null) {
    if (data) {
      this.uid = data.uid ?? ""
      this.status = data.status ?? NegotiationStatus.NotDefined
      this.endDate = data.endDate ?? ""
      this.message = data.message ?? ""
      this.proposedBySupplier = data.proposedBySupplier ?? false
      this.created = data.created ?? ""
      this.reviewed = data.reviewed ?? false
      this.responseMessage = data.responseMessage ?? ""
      this.respondedAt = data.respondedAt ?? ""
      this.proposer = data.proposer ? new UserModel(data.proposer) : null
      this.respondedBy = data.respondedBy
        ? new UserModel(data.respondedBy)
        : null
    }
  }
}
